import { createClient } from "@stringiverse/trpc-client";
import { useMemo } from "react";

interface tRPCState {
	client: ReturnType<typeof createClient>;
}

export const useRPC = () => useMemo(() => createClient(), []);
